import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { discrepancyType } from 'custom/constants';
import { getStationDate } from 'utils/converter';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import airlineLogo from 'utils/airlinelogo';

function getExportQuantity(billingFields, row) {
  function formatNumber(num) {
    return num % 1 === 0 ? Math.round(num) : num.toFixed(2);
  }
  let value;
  if (billingFields?.exclude_disc) {
    if (billingFields?.transit === 'none' || !billingFields?.transit) {
      value = !isNaN(parseFloat(row.quantity)) ? formatNumber(Math.round(parseFloat(row.quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'inbound') {
      value = !isNaN(parseFloat(row.in_quantity)) ? formatNumber(Math.round(parseFloat(row.in_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'outbound') {
      value = !isNaN(parseFloat(row.out_quantity)) ? formatNumber(Math.round(parseFloat(row.out_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'flight' && billingFields?.priority === 'inbound') {
      value = !isNaN(parseFloat(row.in_fquantity)) ? formatNumber(Math.round(parseFloat(row.in_fquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'flight' && billingFields?.priority === 'outbound') {
      value = !isNaN(parseFloat(row.out_fquantity)) ? formatNumber(Math.round(parseFloat(row.out_fquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'truck' && billingFields?.priority === 'inbound') {
      value = !isNaN(parseFloat(row.in_tquantity)) ? formatNumber(Math.round(parseFloat(row.in_tquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'truck' && billingFields?.priority === 'outbound') {
      value = !isNaN(parseFloat(row.out_tquantity)) ? formatNumber(Math.round(parseFloat(row.out_tquantity) * 100) / 100) : parseFloat(0);
    }
  } else {
    if (billingFields?.transit === 'none' || !billingFields?.transit) {
      value = !isNaN(parseFloat(row.dis_quantity)) ? formatNumber(Math.round(parseFloat(row.dis_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'inbound') {
      value = !isNaN(parseFloat(row.dis_in_quantity)) ? formatNumber(Math.round(parseFloat(row.dis_in_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'outbound') {
      value = !isNaN(parseFloat(row.dis_out_quantity)) ? formatNumber(Math.round(parseFloat(row.dis_out_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'flight' && billingFields?.priority === 'inbound') {
      value = !isNaN(parseFloat(row.dis_in_fquantity)) ? formatNumber(Math.round(parseFloat(row.dis_in_fquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'flight' && billingFields?.priority === 'outbound') {
      value = !isNaN(parseFloat(row.dis_out_fquantity)) ? formatNumber(Math.round(parseFloat(row.dis_out_fquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'truck' && billingFields?.priority === 'inbound') {
      value = !isNaN(parseFloat(row.dis_in_tquantity)) ? formatNumber(Math.round(parseFloat(row.dis_in_tquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'truck' && billingFields?.priority === 'outbound') {
      value = !isNaN(parseFloat(row.dis_out_tquantity)) ? formatNumber(Math.round(parseFloat(row.dis_out_tquantity) * 100) / 100) : parseFloat(0);
    }
  }
  return value;
}

const get_csv_cont = async (billingData, billingFields) => {
  let csv_cont = [];
  billingData.map((column) => {
    column?.inbound?.flights.map((flight) => {
      let trimlabel = flight.label?.split(' ')?.[0];
      let data = {
        'Flight': trimlabel?.split('/')?.[0],
        'Date': trimlabel?.split('/')?.[1],
        'Sch Arr Date': flight.schdl_arr ? getStationDate(flight.dest, flight.schdl_arr, 'DDMMMYY') : '',
        'Sch Dept Date': flight.schdl_dept ? getStationDate(flight.org, flight.schdl_dept, 'DDMMMYY') : '',
        'Act Arr Date': flight.act_arr ? getStationDate(flight.dest, flight.act_arr, 'DDMMMYY') : '',
        'Act Dept Date': flight.act_dept ? getStationDate(flight.org, flight.act_dept, 'DDMMMYY') : '',
        'Segment': `${flight.org} - ${flight.dest}`,
        'Type': 'Inbound'
      };
      flight?.contractData.filter(item => item.is_nonbillable !== true).map((row) => {
        data[row.item] = getExportQuantity(billingFields, row);
      });
      csv_cont.push(data);
    });
    column?.outbound?.flights.map((flight) => {
      let trimlabel = flight.label?.split(' ')?.[0];
      let data = {
        'Flight': trimlabel?.split('/')?.[0],
        'Date': trimlabel?.split('/')?.[1],
        'Sch Arr Date': flight.schdl_arr ? getStationDate(flight.dest, flight.schdl_arr, 'DDMMMYY') : '',
        'Sch Dept Date': flight.schdl_dept ? getStationDate(flight.org, flight.schdl_dept, 'DDMMMYY') : '',
        'Act Arr Date': flight.act_arr ? getStationDate(flight.dest, flight.act_arr, 'DDMMMYY') : '',
        'Act Dept Date': flight.act_dept ? getStationDate(flight.org, flight.act_dept, 'DDMMMYY') : '',
        'Segment': `${flight.org} - ${flight.dest}`,
        'Type': 'Outbound'
      };
      flight?.contractData.filter(item => item.is_nonbillable !== true).map((row) => {
        data[row.item] = getExportQuantity(billingFields, row);
      });
      csv_cont.push(data);
    });
  });
  return csv_cont;
};

const get_csvpage_cont = async (sheetType, billingFields, billingData, reportFields, flightSumOpts, flightDetOpts) => {
  // This function generates a summary table from billingData, similar to get_csv_cont,
  // but sums up quantities for noncommercialData columns based on sheetType and removes unnecessary columns.
  let filteredbillingData = cloneDeep(billingData);
  if( sheetType === 'Flight Summary' || sheetType === 'Flight Details') { // exclude statistics from billingData
    filteredbillingData[0].contractData = filteredbillingData[0].contractData.filter(item => item.is_nonbillable !== true);
    filteredbillingData[0].inbound.flights.forEach(flight => {
      flight.contractData = flight.contractData.filter(item => item.is_nonbillable !== true);
    });
    filteredbillingData[0].outbound.flights.forEach(flight => {
      flight.contractData = flight.contractData.filter(item => item.is_nonbillable !== true);
    });
  } else if (sheetType === 'Statistics') { // exclude non statistics from billingData
    filteredbillingData[0].contractData = filteredbillingData[0].contractData.filter(item => item.is_nonbillable == true);
    filteredbillingData[0].inbound.flights.forEach(flight => {
      flight.contractData = flight.contractData.filter(item => item.is_nonbillable == true);
    });
    filteredbillingData[0].outbound.flights.forEach(flight => {
      flight.contractData = flight.contractData.filter(item => item.is_nonbillable == true);
    });
  }

  let csv_cont = [];

  // Helper: For a given contractData array and commercial_items, sum up the quantities
  function sumCommercialItems(contractData, commercial_items, billingFields) {
    let sum = 0;
    contractData.forEach(row => {
      if (commercial_items.includes(parseInt(row.cont_rowId))) {
        sum += parseFloat(getExportQuantity(billingFields, row)) || 0;
      }
    });
    return sum;
  }

  function groupAndSumRows(csv_cont) {
    const grouped = {};

    csv_cont.forEach(row => {
      const key = `${row.Flight}_${row.Type}_${row.Segment}`;
      if (!grouped[key]) {
        grouped[key] = { ...row };
      } else {
        Object.keys(row).forEach(col => {
          if (
            !['Flight', 'Date', 'Segment', 'Type'].includes(col) &&
            !isNaN(parseFloat(row[col]))
          ) {
            // grouped[key][col] = (grouped[key][col] || 0) + row[col];
            const prev = !isNaN(parseFloat(grouped[key][col])) ? parseFloat(grouped[key][col]) : 0;
            const curr = !isNaN(parseFloat(row[col])) ? parseFloat(row[col]) : 0;
            grouped[key][col] = prev + curr;
          }
        });
      }
    });

    return Object.values(grouped);
  }

  // Main logic
  filteredbillingData.forEach(column => {
    ['inbound', 'outbound'].forEach(type => {
      let flights = column?.[type]?.flights || [];
      if (sheetType === 'Flight Details') {
        const getPlatformGroup = (item) => {
          const p = item.platform;
          if (p === null || p === undefined || p === '') {
            return 3;
          }
          if (p === 'Truck') {
            return 2;
          }
          return 1;
        };
        flights = [...flights].sort((a, b) => {
          const groupA = getPlatformGroup(a);
          const groupB = getPlatformGroup(b);
          if (groupA !== groupB) {
            return groupA - groupB;
          }
          const dateStrA = a.label?.split(' ')?.[0]?.split('/')?.[1];
          const dateStrB = b.label?.split(' ')?.[0]?.split('/')?.[1];
          const dateA = moment(dateStrA, 'DDMMMYY');
          const dateB = moment(dateStrB, 'DDMMMYY');
          return dateA - dateB;
        });
      }

      flights.forEach(flight => {
        let trimlabel = flight.label?.split(' ')?.[0];
        let data = {
          'Flight': trimlabel?.split('/')?.[0],
          'Date': trimlabel?.split('/')?.[1],
          'Segment': `${flight.org} - ${flight.dest}`,
          'Type': type.charAt(0).toUpperCase() + type.slice(1),
          'Platform': flight.platform || '',
        };

        // If noncommercialData is present, sum up the columns. Ignore if sheetType is 'Flight Details' or 'Flight Summary'
        if (sheetType !== 'Flight Details' && sheetType !== 'Flight Summary') {
          if (flight.noncommercialData && Array.isArray(flight.noncommercialData) && sheetType) {
            // const nonCommercialCols = getNonCommercialColumns(flight.noncommercialData, sheetType);
            const nonCommercialCols = flight.noncommercialData;
            nonCommercialCols.forEach(nc => {
              // Sum up all contractData rows whose id is in nc.commercial_items
              const sum = sumCommercialItems(flight.contractData || [], nc.commercial_items || [], billingFields);
              data[nc.description] = sum;
            });
          }
        }

        // Always include all contractData items as columns (like get_csv_cont)
        if (flight.contractData && Array.isArray(flight.contractData)) {
          flight.contractData.forEach(row => {
            data[row.item] = getExportQuantity(billingFields, row);
          });
        }

        csv_cont.push(data);
      });
    });
  });

  if (sheetType === 'Flight Summary') {
    if (reportFields.reportType === 'custom' && sheetType === 'Flight Summary') {
      if (
        Array.isArray(flightSumOpts) && flightSumOpts.length > 0
      ) {
        // Get allowed columns from fSumOpts
        const allowedCols = [
          'Flight',
          'Segment',
          'Type',
          ...flightSumOpts.map(opt => opt.title)
        ];

        csv_cont = csv_cont.map(row => {
          let filtered = {};
          allowedCols.forEach(col => {
            if (Object.prototype.hasOwnProperty.call(row, col)) filtered[col] = row[col];
          });
          return filtered;
        });
      }
    }
    csv_cont = groupAndSumRows(csv_cont);
  }

  else if (
    reportFields.reportType === 'custom' && sheetType === 'Flight Details' &&
    Array.isArray(flightDetOpts) && flightDetOpts.length > 0
  ) {
    // Get allowed columns from fDetOpts
    const allowedCols = [
      'Flight',
      'Date',
      'Segment',
      'Type',
      'Platform',
      ...flightDetOpts.map(opt => opt.title)
    ];

    csv_cont = csv_cont.map(row => {
      let filtered = {};
      allowedCols.forEach(col => {
        if (Object.prototype.hasOwnProperty.call(row, col)) filtered[col] = row[col];
      });
      return filtered;
    });
  }
  return csv_cont;
};

const get_tonnage_summary = async (csvContracts = [], contractData = [], reportFields, billingFields, tonSumOpts) => {
  let csv_cont = [];
  let sheetType = [
    'Flight Summary',
    'Flight Details',
  ];  
  //filter out statistics from contractData.
  contractData = contractData.filter(item => item.is_nonbillable !== true);

  // 1. For each csvContract, sum up contractData records whose id is in commercial_items
  csvContracts.forEach(contract => {
    if (contract.sheetlist && !sheetType.some(type => contract.sheetlist.includes(type))) return;
    const ids = contract.commercial_items || [];
    // Find all contractData records with id in ids
    const matched = contractData.filter(row => ids.includes(row.row_id));
    // Sum up the fields
    let sum_quantity = 0, sum_dis_quantity = 0;
    let sum_driver = '', sum_source = '';
    matched.forEach(row => {
      sum_quantity += parseFloat(row.quantity) || 0;
      sum_dis_quantity += parseFloat(row.dis_quantity) || 0;
      // Use the first non-empty driver/source for display
      if (!sum_driver && row.applied_on) sum_driver = row.applied_on.split('|')[0]?.trim();
      if (!sum_source && row.applied_on) sum_source = row.applied_on.split('|')[1]?.trim();
    });
    // Only add if there is at least one matched record
    if (matched.length > 0) {
      csv_cont.push({
        'Item': contract.description,
        'Driver': sum_driver,
        'Source': sum_source,
        'Quantity': billingFields.exclude_disc ? sum_quantity : sum_dis_quantity,
      });
    }
  });

  // 2. For contractData records whose id is NOT present in any csvContract's commercial_items, add as-is
  let allCommercialIds = new Set();
  csvContracts.forEach(contract => {
    (contract.commercial_items || []).forEach(id => allCommercialIds.add(id));
  });
  contractData.forEach(row => {
    // if (!allCommercialIds.has(row.row_id)) {
    csv_cont.push({
      'Item': row.label,
      'Driver': row.applied_on ? row.applied_on.split('|')[0]?.trim() : '',
      'Source': row.applied_on ? row.applied_on.split('|')[1]?.trim() : '',
      'Quantity': getExportQuantity(billingFields, row),
    });
    // }
  });

  if (
    reportFields.reportType === 'custom' &&
    Array.isArray(tonSumOpts) &&
    tonSumOpts.length > 0
  ) {
    const allowedItems = tonSumOpts.map(opt => opt.title);
    csv_cont = csv_cont.filter(row => allowedItems.includes(row.Item));
  }
  csv_cont = csv_cont.map(row => {
    const newRow = {};
    Object.keys(row).forEach(key => {
      newRow[key] = row[key];
      if (key === 'Quantity') {
        newRow[key] = parseFloat(newRow[key]) || 0;
      }
    });
    return newRow;
  });
  return csv_cont;
};

const addSummaryRows = (rows) => {
  if (!rows || rows.length === 0) return [];

  // Use the first row's keys as the column order
  const keys = Object.keys(rows[0]);

  function sumRows(type) {
    const filtered = rows.filter(row => row.Type === type);
    const summary = {};
    keys.forEach(key => {
      if (['Flight', 'Date', 'Platform', 'Segment', 'Type'].includes(key)) return;
      summary[key] = filtered.reduce((acc, row) => {
        const val = row[key];
        return acc + (val !== undefined && val !== null && val !== '' && !isNaN(val) ? parseFloat(val) : 0);
      }, 0);
    });
    summary.Flight = type === 'Inbound' ? 'Import' : 'Export';
    summary.Date = '';
    summary.Segment = '';
    summary.Type = type;
    summary.Platform = '';
    // Ensure column order and fill missing columns with 0
    return keys.reduce((acc, key) => {
      acc[key] = summary[key] !== undefined ? summary[key] : 0;
      return acc;
    }, {});
  }

  // Add Total row (sum all rows)
  const totalRow = {};
  keys.forEach(key => {
    if (['Flight', 'Date', 'Segment', 'Type', 'Platform'].includes(key)) return;
    totalRow[key] = rows.reduce((acc, row) => {
      const val = row[key];
      return acc + (val !== undefined && val !== null && val !== '' ? parseFloat(val) || 0 : 0);
    }, 0);
  });
  totalRow.Flight = 'Total';
  totalRow.Date = '';
  totalRow.Platform = '';
  totalRow.Segment = '';
  totalRow.Type = '';
  // Ensure column order
  const totalRowOrdered = keys.reduce((acc, key) => {
    acc[key] = totalRow[key] !== undefined ? totalRow[key] : '';
    return acc;
  }, {});

  // Find first inbound and outbound row indexes
  const firstInboundIdx = rows.findIndex(row => row.Type === 'Inbound');
  const firstOutboundIdx = rows.findIndex(row => row.Type === 'Outbound');

  const result = [...rows];

  if (firstInboundIdx !== -1) {
    result.splice(firstInboundIdx, 0, sumRows('Inbound'));
  }
  if (firstOutboundIdx !== -1) {
    const offset = firstInboundIdx !== -1 && firstOutboundIdx > firstInboundIdx ? 1 : 0;
    result.splice(firstOutboundIdx + offset, 0, sumRows('Outbound'));
  }

  // Insert Total row at the top
  result.unshift(totalRowOrdered);

  return result;
};

const get_service_logs_csv = async (daylogdata = [], monthlogdata = []) => {
  // Only finalized logs
  daylogdata = daylogdata.filter(row => row.status !== 'Not Finalized');
  monthlogdata = monthlogdata.filter(row => row.status !== 'Not Finalized');
  // Helper to flatten contractData for each log
  function flattenContractData(contractData, notes) {
    const result = {};
    contractData.forEach(item => {
      // Use item.label as column prefix
      result[`${item.label.charAt(0).toUpperCase() + item.label.slice(1)} (Quantity)`] = item.quantity;
      // Add more fields if needed
      const filteredNotes = notes.filter(note => note.cont_rowId === item.cont_rowId);
      // set column name as notes and put data comma separated
      result[`${item.label.charAt(0).toUpperCase() + item.label.slice(1)} (Notes)`] = filteredNotes.map(n => n.note).join(', ');
    });
    return result;
  }

  // Build rows for Excel
  let csvRows = [];
  daylogdata.forEach(log => {
    let row = {
      'Label': log.label,
      'Type': log.type,
      ...flattenContractData(log.contractData, log.notes)
    };
    csvRows.push(row);
  });

  monthlogdata.forEach(log => {
    let row = {
      'Label': log.label,
      'Type': log.type,
      ...flattenContractData(log.contractData, log.notes)
    };
    csvRows.push(row);
  });
  return csvRows;
};

const get_transit_awbs_csv = async (invoiceData = {}) => {
  let csv_transit_awbs = [];
  if (invoiceData && invoiceData.inflightcontracts && Array.isArray(invoiceData.inflightcontracts) && invoiceData.inflightcontracts.length > 0) {
    invoiceData.inflightcontracts.forEach(contract => {
      if (contract.transit_awbs && Array.isArray(contract.transit_awbs) && contract.transit_awbs.length > 0) {
        contract.transit_awbs.forEach(awb => {
          csv_transit_awbs.push({
            // 07Apr26
            'In Flight': awb?.inboundInfo && awb?.inboundInfo?.flight ? awb?.inboundInfo?.flight?.airline + awb?.inboundInfo?.flight?.flight_no + '/' + moment(awb?.inboundInfo?.flight?.flight_date).format('DDMMMYY') + ' (' + awb?.inboundInfo?.platform + ')' : '',
            'AWB': awb?.awb_no + ' (' +awb?.org + '-' + awb?.dest + ')' || '',
            'Label': awb?.label || '',
            'Value': awb?.qtyValue || '',
            'Out Flight': awb?.outboundInfo && awb?.outboundInfo?.flight ? awb?.outboundInfo?.flight?.airline + awb?.outboundInfo?.flight?.flight_no + '/' + moment(awb?.outboundInfo?.flight?.flight_date).format('DDMMMYY') + ' (' + awb?.outboundInfo?.platform + ')' : '',
          });
        });
      }
    });
  }
  if (invoiceData && invoiceData.outflightcontracts && Array.isArray(invoiceData.outflightcontracts) && invoiceData.outflightcontracts.length > 0) {
    invoiceData.outflightcontracts.forEach(contract => {
      if (contract.transit_awbs && Array.isArray(contract.transit_awbs) && contract.transit_awbs.length > 0) {
        contract.transit_awbs.forEach(awb => {
          csv_transit_awbs.push({
            'In Flight': awb?.inboundInfo && awb?.inboundInfo?.flight ? awb?.inboundInfo?.flight?.airline + awb?.inboundInfo?.flight?.flight_no + '/' + moment(awb?.inboundInfo?.flight?.flight_date).format('DDMMMYY') + ' (' + awb?.inboundInfo?.platform + ')' : '',
            'AWB': awb?.awb_no + ' (' +awb?.org + '-' + awb?.dest + ')' || '',
            'Label': awb?.label || '',
            'Value': awb?.qtyValue || '',
            'Out Flight': awb?.outboundInfo && awb?.outboundInfo?.flight ? awb?.outboundInfo?.flight?.airline + awb?.outboundInfo?.flight?.flight_no + '/' + moment(awb?.outboundInfo?.flight?.flight_date).format('DDMMMYY') + ' (' + awb?.outboundInfo?.platform + ')' : '',
          });
        });
      }
    });
  }
  return csv_transit_awbs;
};

const get_csv_stat = async (billingData, billingColumns) => {
  console.log('Statistics Data:!!!!!!!!!!!!!!!!!1,', billingData);
  let csv_stat = [];
  billingData.map((column) => {
    csv_stat = [];
    let data = {
      'Lable': column?.ex_label,
      'Date': '',
      'Segment': '',
      'Sch Arr Date': '',
      'Sch Dept Date': '',
      'Act Arr Date': '',
      'Act Dept Date': '',
      'Flight': column?.flight_count,

    };
    billingColumns.map((c) => {
      let field = c.field;
      // if (this.state.billingFields.exclude_disc) {
      //   field = field.replace('_disc', '');
      // }
      data[c.headerName] = column?.[field];
    });
    csv_stat.push(data);
    data = {};
    data = {
      'Lable': column?.inbound?.ex_label,
      'Date': '',
      'Segment': '',
      'Sch Arr Date': '',
      'Sch Dept Date': '',
      'Act Arr Date': '',
      'Act Dept Date': '',
      'Flight': column?.inbound?.flight_count,
    };
    billingColumns.map((c) => {
      let field = c.field;
      data[c.headerName] = column?.inbound?.[field];
    });
    csv_stat.push(data);
    //inbound flights
    if (column?.inbound?.flights?.length > 0) {
      column?.inbound?.flights.map((flight) => {
        data = {};
        let trimlabel = flight.label?.split(' ')?.[0];
        data = {
          'Lable': trimlabel?.split('/')?.[0],
          'Date': trimlabel?.split('/')?.[1],
          'Segment': `${flight.org} - ${flight.dest}`,
          'Sch Arr Date': flight.schdl_arr ? getStationDate(flight.dest, flight.schdl_arr, 'DDMMMYY') : '',
          'Sch Dept Date': flight.schdl_dept ? getStationDate(flight.org, flight.schdl_dept, 'DDMMMYY') : '',
          'Act Arr Date': flight.act_arr ? getStationDate(flight.dest, flight.act_arr, 'DDMMMYY') : '',
          'Act Dept Date': flight.act_dept ? getStationDate(flight.org, flight.act_dept, 'DDMMMYY') : '',
          'Flight': flight.flight_count,
        };
        billingColumns.map((c) => {
          let field = c.field;
          data[c.headerName] = flight[field];
        });
        csv_stat.push(data);
      });
    }
    data = {};
    data = {
      'Lable': column?.outbound?.ex_label,
      'Date': '',
      'Segment': '',
      'Sch Arr Date': '',
      'Sch Dept Date': '',
      'Act Arr Date': '',
      'Act Dept Date': '',
      'Flight': column?.outbound?.flight_count,
    };
    billingColumns.map((c) => {
      let field = c.field;
      data[c.headerName] = column?.outbound?.[field];
    });
    csv_stat.push(data);
    //outbound flights
    if (column?.outbound?.flights?.length > 0) {
      column?.outbound?.flights.map((flight) => {
        data = {};
        let trimlabel = flight.label?.split(' ')?.[0];
        data = {
          'Lable': trimlabel?.split('/')?.[0],
          'Date': trimlabel?.split('/')?.[1],
          'Segment': `${flight.org} - ${flight.dest}`,
          'Sch Arr Date': flight.schdl_arr ? getStationDate(flight.dest, flight.schdl_arr, 'DDMMMYY') : '',
          'Sch Dept Date': flight.schdl_dept ? getStationDate(flight.org, flight.schdl_dept, 'DDMMMYY') : '',
          'Act Arr Date': flight.act_arr ? getStationDate(flight.dest, flight.act_arr, 'DDMMMYY') : '',
          'Act Dept Date': flight.act_dept ? getStationDate(flight.org, flight.act_dept, 'DDMMMYY') : '',
          'Flight': flight.flight_count,
        };
        billingColumns.map((c) => {
          let field = c.field;
          data[c.headerName] = flight[field];
        });
        csv_stat.push(data);
      });
    }
  });
  return csv_stat;
};

export const handleExport = async (contractData, billingFields, billingData, flightList, csvContracts, reportFields, flightSumOpts, flightDetOpts,
  tonSumOpts, daylogdata, monthlogdata, billingColumns, searchFields,
  fetchInvoiceData, fetchProducts, fetchDiscrepancies, invoiceData = {}, statisticsSummary) => {
  // const state = { ...this.state };
  let csv_discdetails = [];
  // eslint-disable-next-line no-unused-vars
  let csv_contract = [{}];
  let csv_stat = [{}];
  let csv_disc = [{}];
  // eslint-disable-next-line no-unused-vars
  let csv_invoice = [{}];
  let csv_flightsummary = [{}];
  let csv_flightdetails = [{}];
  let tonngage_summary = [{}];
  let csv_servicelogs = [{}];
  let transit_awbs = [{}];
  let statistics = [{}];
  await fetchInvoiceData(false, 'excel', async (status, contractData, csvContracts, daylogdata, monthlogdata, billingData) => {
    if (status) {
      if (contractData && contractData.length > 0) {
        csv_contract = contractData
          .filter((item) => item.is_nonbillable !== true)
          .map((row) => {
            return {
              Item: row.item,
              Driver: row.driver,
              Source: row.source,
              Quantity: getExportQuantity(billingFields, row),
            };
          });
        csv_invoice = (await get_csv_cont(billingData, billingFields)) || [{}];
        csv_flightsummary = (await get_csvpage_cont('Flight Summary', billingFields, billingData, reportFields, flightSumOpts, flightDetOpts)) || [{}];
        csv_flightdetails = (await get_csvpage_cont('Flight Details', billingFields, billingData, reportFields, flightSumOpts, flightDetOpts)) || [{}];
        tonngage_summary = (await get_tonnage_summary(csvContracts, contractData, reportFields, billingFields, tonSumOpts)) || [{}];
        csv_servicelogs = (await get_service_logs_csv(daylogdata, monthlogdata)) || [{}];
        transit_awbs = (await get_transit_awbs_csv(invoiceData)) || [{}];
        statistics = (await get_csvpage_cont('Statistics', billingFields, billingData, reportFields, flightSumOpts, flightDetOpts)) || [{}];

        //add missing labels from rows in csv_flightsummary and csv_flightdetails
        // Get all unique keys from all rows
        const allKeys1 = Array.from(
          new Set(csv_flightsummary.flatMap((row) => Object.keys(row)))
        );
        // Normalize each row to have all keys, filling missing values with 0
        csv_flightsummary = csv_flightsummary.map((row) => {
          const normalized = {};
          allKeys1.forEach((key) => {
            // Keep original value if present, else set to 0 (except for Flight, Date, Segment, Type)
            if (['Flight', 'Segment', 'Type'].includes(key)) {
              normalized[key] = row[key] !== undefined ? row[key] : '';
            } else {
              normalized[key] = row[key] !== undefined ? row[key] : 0;
            }
          });
          return normalized;
        });
        const allKeys2 = Array.from(
          new Set(csv_flightdetails.flatMap((row) => Object.keys(row)))
        );
        // Normalize each row to have all keys, filling missing values with 0
        csv_flightdetails = csv_flightdetails.map((row) => {
          const normalized = {};
          allKeys2.forEach((key) => {
            // Keep original value if present, else set to 0 (except for Flight, Date, Platform, Segment, Type)
            if (['Flight', 'Date', 'Segment', 'Type', 'Platform'].includes(key)) {
              normalized[key] = row[key] !== undefined ? row[key] : '';
            } else {
              normalized[key] = row[key] !== undefined ? row[key] : 0;
            }
          });
          return normalized;
        });

        // Usage before filtering with fs_labels:
        csv_flightsummary = await addSummaryRows(csv_flightsummary);
        csv_flightsummary = csv_flightsummary.map((row) => {
          const { Date: _Date, ...rest } = row;
          return rest;
        });
        csv_flightdetails = await addSummaryRows(csv_flightdetails);
      }
    }
    // this.setState({
    //   flightList: [],
    //   billingData: [],
    //   filteredData: [],
    //   contractData: [],
    //   accord_id: null,
    //   accord_type: null,
    // });
    fetchProducts('excel', async (status, billingData, billingColumns) => {
      console.log('fetchProducts billingColumns++++++++++++++++++++++++++++++++++', billingData);
      if (status) {
        csv_stat = (await get_csv_stat(billingData, billingColumns)) || [{}];
      }
      // this.setState({
      //   flightList: [],
      //   billingData: [],
      //   filteredData: [],
      //   contractData: [],
      //   accord_id: null,
      //   accord_type: null,
      // });
      fetchDiscrepancies(null, 'excel', async (status, flightList) => {
        console.log('fetchDiscrepancies status', status);
        if (status) {
          if (billingData.length > 0) {
            csv_disc = [];
            discrepancyType.map((type) => {
              csv_disc.push({
                Type: type,
                Total: billingData[0][type],
                Inbound: billingData[0]?.inbound[type],
                Outbound: billingData[0]?.outbound[type],
              });
            });
          }
          console.log('flightList______________________', flightList.length);
          if (flightList.length > 0) {
            let inbound_data = flightList[0].inbound || [];
            let outbound_data = flightList[0].outbound || [];
            await Promise.all(
              inbound_data.map(async (flight) => {
                console.log('flight?.flight_discrepancies______________________', flight?.flight_discrepancies.length);
                if (
                  flight?.flight_discrepancies &&
                  flight.flight_discrepancies.length > 0
                ) {
                  flight.flight_discrepancies.map((disc) => {
                    csv_discdetails.push({
                      Flight:
                        '' + flightList[0].code + flight.flight_no,
                      Date: flight?.flight_date,
                      Type: 'Inbound',
                      'Discrepancy Type': disc.type,
                      'ULD Number': disc.uld_no,
                      'Handled As': disc.handled_as,
                      Segment: disc.segment === 'null' ? '' : disc.segment,
                      'ULD Type':
                        disc.uld_type === 'null' ? '' : disc.uld_type,
                      'AWB Number': disc.awb_no,
                      Org: disc.org,
                      Dest: disc.dest,
                      'Total Pcs': disc.t_pcs,
                      'Total Wgt': disc.t_wgt,
                      'Dscpy Pcs': disc.d_pcs,
                      'Dscpy Wgt': disc.d_wgt,
                      Remarks: disc.description,
                    });
                  });
                }
              })
            );
            await Promise.all(
              outbound_data.map(async (flight) => {
                console.log('flight?.flight_discrepancies______________________', flight?.flight_discrepancies.length);
                if (
                  flight?.flight_discrepancies &&
                  flight.flight_discrepancies.length > 0
                ) {
                  flight.flight_discrepancies.map((disc) => {
                    csv_discdetails.push({
                      Flight:
                        '' + flightList[0].code + flight.flight_no,
                      Date: flight?.flight_date,
                      Type: 'Outbound',
                      'Discrepancy Type': disc.type,
                      'ULD Number': disc.uld_no,
                      'Handled As': disc.handled_as,
                      Segment: disc.segment === 'null' ? '' : disc.segment,
                      'ULD Type':
                        disc.uld_type === 'null' ? '' : disc.uld_type,
                      'AWB Number': disc.awb_no,
                      Org: disc.org,
                      Dest: disc.dest,
                      'Total Pcs': disc.t_pcs,
                      'Total Wgt': disc.t_wgt,
                      'Dscpy Pcs': disc.d_pcs,
                      'Dscpy Wgt': disc.d_wgt,
                      Remarks: disc.description,
                    });
                  });
                }
              })
            );
          }
        }     

        const workbookJs = new ExcelJS.Workbook();
        const sheet1 = workbookJs.addWorksheet('Tonnage Summary');
        const sheet2 = workbookJs.addWorksheet('Flight Summary');
        const sheet3 = workbookJs.addWorksheet('Flight Details');
        const sheet8 = workbookJs.addWorksheet('Discrepancy Details');
        // const sheet4 = workbookJs.addWorksheet('Contract');
        let sheet5;
        if(statisticsSummary === true) {
          sheet5 = workbookJs.addWorksheet('Statistics Summary');
        }
        const sheet11 = workbookJs.addWorksheet('Statistics');
        const sheet9 = workbookJs.addWorksheet('Service Logs Details');
        const sheet10 = workbookJs.addWorksheet('Transit AWBs');
        // const sheet6 = workbookJs.addWorksheet('Discrepancy');
        // const sheet7 = workbookJs.addWorksheet('Invoice');
        console.log('Search Fields:', searchFields);
        let imageId;
        if(searchFields.airlineCode) {
          const logo = airlineLogo(searchFields.airlineCode);
          console.log('Airline Logo:', logo);
          // Fetching the logo (remote/CORS/asset) can fail; don't let that abort the whole export.
          if(logo) {
            try {
              const response = await fetch(logo);
              if (!response.ok) {
                throw new Error(`Unable to fetch airline logo: ${response.status}`);
              }
              const buffer = await response.arrayBuffer();

              const extension = logo.toLowerCase().includes('.jpg') || logo.toLowerCase().includes('.jpeg')
                ? 'jpeg'
                : 'png';
              imageId = workbookJs.addImage({
                buffer: new Uint8Array(buffer),
                extension: extension,
              });
            } catch (err) {
              console.error('Failed to attach airline logo to export:', err);
              imageId = undefined;
            }
          }
        }
        if (imageId !== undefined) {
          const logoPlacement = {
            tl: {
              col: 0,
              row: 0 
            },
            ext: {
              width: 170,
              height: 100 
            }
          };
          sheet1.addImage(imageId, logoPlacement);
          sheet2.addImage(imageId, logoPlacement);
          sheet3.addImage(imageId, logoPlacement);
          // sheet4.addImage(imageId, logoPlacement);
          sheet5 && sheet5.addImage(imageId, logoPlacement);
          // sheet6.addImage(imageId, logoPlacement);
          // sheet7.addImage(imageId, logoPlacement);
          sheet8.addImage(imageId, logoPlacement);
          sheet9.addImage(imageId, logoPlacement);
          sheet10.addImage(imageId, logoPlacement);
          sheet11.addImage(imageId, logoPlacement);
          sheet1.mergeCells('A1:A5');
          sheet2.mergeCells('A1:B5');
          sheet3.mergeCells('A1:B5  ');
          // sheet4.mergeCells('A1:B4');
          sheet5 && sheet5.mergeCells('A1:B5');
          // sheet6.mergeCells('A1:B4');
          // sheet7.mergeCells('A1:B4');
          sheet8.mergeCells('A1:B5');
          sheet9.mergeCells('A1:B5');
          sheet10.mergeCells('A1:B5');
          sheet11.mergeCells('A1:B5');
        }
        sheet1.addRow(Object.keys(tonngage_summary[0] || {}));
        sheet2.addRow(Object.keys(csv_flightsummary[0] || {}));
        sheet3.addRow(Object.keys(csv_flightdetails[0] || {}));
        // sheet4.addRow(Object.keys(csv_contract[0] || {}));
        sheet5 && sheet5.addRow(Object.keys(csv_stat[0] || {}));
        // sheet6.addRow(Object.keys(csv_disc[0] || {}));
        // sheet7.addRow(Object.keys(csv_invoice[0] || {}));
        const discrepancyHeaders = [
          'Flight',
          'Date',
          'Type',
          'Discrepancy Type',
          'ULD Number',
          'Handled As',
          'Segment',
          'ULD Type',
          'AWB Number',
          'Org',
          'Dest',
          'Total Pcs',
          'Total Wgt',
          'Dscpy Pcs',
          'Dscpy Wgt',
          'Remarks',
        ];
        sheet8.addRow(discrepancyHeaders);
        sheet9.addRow(Object.keys(csv_servicelogs[0] || {}));
        sheet10.addRow(Object.keys(transit_awbs[0] || {}));
        const statisticsHeaders = Array.from(new Set(statistics.flatMap((row) => Object.keys(row))));
        sheet11.addRow(statisticsHeaders);

        sheet1.addRows(tonngage_summary.map((row) => Object.values(row)));
        sheet2.addRows(csv_flightsummary.map((row) => Object.values(row)));
        sheet3.addRows(csv_flightdetails.map((row) => Object.values(row)));
        // sheet4.addRows(csv_contract.map((row) => Object.values(row)));
        sheet5 && sheet5.addRows(csv_stat.map((row) => Object.values(row)));
        // sheet6.addRows(csv_disc.map((row) => Object.values(row)));
        // sheet7.addRows(csv_invoice.map((row) => Object.values(row)));
        sheet8.addRows(csv_discdetails.map((row) => discrepancyHeaders.map((header) => row[header] ?? '')));
        sheet9.addRows(csv_servicelogs.map((row) => Object.values(row)));
        sheet10.addRows(transit_awbs.map((row) => Object.values(row)));
        sheet11.addRows(statistics.map((row) => statisticsHeaders.map((header) => row[header] ?? '')));
        // for all sheet increse column width for based on max content of column and if numneric value then align right
        const sheets = workbookJs.worksheets;
        sheets.forEach(sheet => {
          if (sheet.columnCount === 0) return;
          sheet.columns.forEach(column => {
            let maxLength = 10;
            column.eachCell({ includeEmpty: true }, cell => {
              const columnLength = cell.value ? cell.value.toString().length : 0;
              if (columnLength > maxLength) {
                maxLength = columnLength;
              }
              console.log('Cell value:', cell.value, typeof cell.value, parseFloat(cell.value)?.toString() === cell.value);
              if (typeof cell.value === 'number') {
                cell.alignment = { horizontal: 'right' };
              }
            });
            column.width = maxLength + 2;
            column.alignment = { wrapText: true };
          });
        });

        const colorSheets = [sheet2, sheet3];
        colorSheets.forEach(sheet => {
          sheet.eachRow((row) => {
            let hasTotal = false;
            let hasImportOrExport = false;
            row.eachCell((cell) => {
              if (cell.value === 'Total') {
                hasTotal = true;
              }
              if (cell.value === 'Import' || cell.value === 'Export') {
                hasImportOrExport = true;
              }
            });
            if (hasTotal) {
              row.eachCell((cell) => {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFC000' },
                };
              });
            }
            if (hasImportOrExport) {
              row.eachCell((cell) => {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFFF00' },
                };
              });
            }
          });
        });
        sheet2.getRow(6).height = 1.69 * 28.35;
        sheet3.getRow(6).height = 1.69 * 28.35;
        let filename = 'Flight Load Info';

        // Build filename parts from billingFields
        const parts = [];
        parts.push(searchFields.month);
        if (!billingFields?.exclude_disc) parts.push('dis');
        if (billingFields?.transit && billingFields.transit !== 'none') parts.push(billingFields.transit);
        if (billingFields?.priority && (billingFields.transit === 'flight' || billingFields.transit === 'truck')) parts.push(billingFields.priority);

        if (parts.length > 0) {
          filename += ' - ' + parts.join('_');
        }

        filename += '.xlsx';
        const buffer = await workbookJs.xlsx.writeBuffer();

        saveAs(
          new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', }),
          filename
        );
        // this.setState({ ...state });
      });
    });
  });

};
